import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UserActivityService {

  private inactivityLimit = 45 * 60 * 1000; // 45 minutos
  private lastActivityTime = Date.now();
  private checkInterval: any = null;
  private throttleInterval = 30 * 1000; // Solo registrar actividad cada 30 segundos

  private events = ['mousemove', 'keydown', 'click', 'scroll', 'focus', 'blur'];

  private activityHandler = () => {
    const now = Date.now();
    // Solo actualiza la fecha si pasaron más de 30 segundos desde el último registro
    if (now - this.lastActivityTime > this.throttleInterval) {
      this.lastActivityTime = now;
    }
  };

  startWatching(lastUrl: string) {
    this.lastActivityTime = Date.now();

    this.events.forEach(event => {
      window.addEventListener(event, this.activityHandler, { passive: true });
    });

    this.checkInterval = setInterval(() => {
      const now = Date.now();
      const diff = now - this.lastActivityTime;

      if (diff >= this.inactivityLimit) {
        this.stopWatching();
        window.location.href =
          '/notfoundpage?fromUrl=' + encodeURIComponent(lastUrl);
      }
    }, 15000);
  }

  stopWatching() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }

    this.events.forEach(event => {
      window.removeEventListener(event, this.activityHandler);
    });
  }
}